import e from "i18n-iso-countries";
import * as t from "i18n-iso-countries/langs/en.json";
//#region src/countries/utilize-localized-countries.ts
var n = (t) => e.langs().includes(t), r = (t) => {
	e.registerLocale(t);
};
r(t);
var i = async (e) => {
	let t = e.toLowerCase();
	try {
		return await import(
			/* @vite-ignore */
			`i18n-iso-countries/langs/${t}.json`
).then((e) => e.default);
	} catch (e) {
		console.error(`Failed to load country locale for: ${t}`, e);
	}
}, a = async (e) => {
	let t = await i(e);
	return t && !n(t.locale) && r(t), t;
};
//#endregion
export { n as isLocalizedCountriesRegistered, i as loadLocalizedCountries, r as registerLocalizedCountries, a as utilizeLocalizedCountries };
